module.exports = __webpack_public_path__ + "static/media/hologram.2a61281a.png";